/**
 * AfricanDrums – the soundboard route.
 *
 * The board itself lives in `features/drums/components/DrumSoundboard`, so it
 * can also be mounted as a section of the drum landing page. This file is the
 * route binding and nothing else.
 *
 * Open to everyone; no sign-in required.
 */

import React from 'react';
import { DrumSoundboard } from '../features/drums/components/DrumSoundboard';

export const AfricanDrums: React.FC = () => <DrumSoundboard />;
